import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useReveal } from "@/hooks/useReveal";
import Hero from "./components/Hero";
import Opportunity from "./components/Opportunity";
import Solutions from "./components/Solutions";
import Process from "./components/Process";
import Numbers from "./components/Numbers";
import Products from "./components/Products";
import Impact from "./components/Impact";
import About from "./components/About";
import Faq from "./components/Faq";
import Cta from "./components/Cta";
import Contact from "./components/Contact";

export default function Home() {
  const containerRef = useReveal<HTMLDivElement>(0.12);

  return (
    <div ref={containerRef} className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Opportunity />
        <Solutions />
        <Process />
        <Numbers />
        <Products />
        <Impact />
        <About />
        <Faq />
        <Cta />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}